<div ngForm="form" class="d-flex flex-column h-100">
	@if (value) {
		<div class="flex-grow-1 overflow-auto">
			@if ((eLinkUrl.touched || bannerMessage.touched) && !value.link && !value.message) {
				<div class="margin-bottom-15" role="alert" vbUiErrorMessage>
					{{ 'Event_Banner_MissingFields' | translate }}
				</div>
			}

			<div layout="row" class="margin-bottom-15">
				<vb-ui-form-group flex="100">
					<label #uiLabel>{{ 'Event_Banner_Title' | translate }}</label>
					<input type="text" name="eLinkName" class="form-control input-with-icon" [attr.aria-label]="'Event_Banner_Title' | translate" [placeholder]="'Event_Banner_Title' | translate" [(ngModel)]="value.name" (ngModelChange)="onNameChange()" #eLinkName="ngModel" trim="blur" uiControl vbRequired vbUiTextInput/>
					<div *ngIf="eLinkName.touched && eLinkName.invalid" role="alert" vbUiErrorMessage uiValidation>
						@if (eLinkName.errors.required) {
							{{ 'ThisFieldIsRequired' | translate }}
						} @else if (eLinkName.errors.duplicateName) {
							{{ 'Event_Banner_Duplicate' | translate }}
						}
					</div>
				</vb-ui-form-group>
			</div>

			<div layout="row" class="margin-bottom-15">
				<vb-ui-form-group flex="100" class="width-full">
					<label #uiLabel>{{ 'Message' | translate }}</label>
					<vb-ui-html-editor name="bannerMessage" [attr.aria-label]="'Message' | translate" [placeholder]="'Message' | translate" [(ngModel)]="value.message" (ngModelChange)="onMessageChange()" [editorConfig]="editorConfig" [themedToolbarMode]="themedHtmlEditor" #htmlEditor #bannerMessage="ngModel" [required]="!value.link" uiControl>
					</vb-ui-html-editor>
				</vb-ui-form-group>
			</div>

			<div layout="row" class="margin-bottom-15">
				<vb-ui-form-group flex="100">
					<label #uiLabel>{{ 'Event_Banner_LinkURL' | translate }}</label>
					<textarea type="text" class="form-control padding-top-5" name="eLinkUrl" [attr.aria-label]="'Event_Banner_LinkURL' | translate" [placeholder]="'Link' | translate" [(ngModel)]="value.link" (ngModelChange)="validateUrl()" [required]="!value.message" #eLinkUrl="ngModel" rows="1" trim="blur" uiControl vbUiTextInput>
					</textarea>
					<div *ngIf="eLinkUrl.touched && eLinkUrl.invalid && eLinkUrl.errors?.invalidCode" role="alert" vbUiErrorMessage uiValidation>
						{{ 'Event_Banner_LinkURL_Invalid' | translate}}
					</div>
				</vb-ui-form-group>
			</div>

			<div layout="row" class="margin-bottom-15">
				<vb-ui-form-group flex="100">
					<label id="bannerPushMethodLabel" #uiLabel>{{ 'Event_Banner_DisplayOptions' | translate }}</label>
					<select id="bannerPushMethod" name="eLinkPushMethod" class="form-select" [(ngModel)]="value.pushMethod" (ngModelChange)="onPushMethodChange()" [attr.aria-labelledby]="'bannerPushMethodLabel'" uiControl>
						<option [ngValue]="'Manual'">{{ 'Event_Banner_DisplayOptions_Manual' | translate }}</option>
						<option [ngValue]="'AtEnd'">{{ 'Event_Banner_DisplayOptions_AtEnd' | translate }}</option>
					</select>
				</vb-ui-form-group>
			</div>
		</div>

		<div layout="row" class="margin-bottom-15 mt-auto" flex-justify="end">
			@if (themedHtmlEditor) {
				<button type="button" [attr.aria-label]="'Cancel' | translate" (click)="onCancelClick()" vbBtnSecondary>
					{{ 'Cancel' | translate }}
				</button>
			} @else {
				<button type="button" [attr.aria-label]="'Cancel' | translate" (click)="onCancelClick()" vbBtnWhite>
					{{ 'Cancel' | translate }}
				</button>
			}
			<button type="button" class="margin-left-5" [attr.aria-label]="(isEditMode ? 'Update' : 'Add') | translate" [disabled]="form.invalid" (click)="onSubmit()" vbBtnPrimary>
				{{ (isEditMode ? 'Update' : 'Add') | translate }}
			</button>
		</div>
	}
</div>
